import { useEffect } from 'react';
import { useQuery } from '@tanstack/react-query';
import { useDispatch } from 'react-redux';
import { deepClone } from '@tenant/utility/helper/Utils';
import { getAuditLogQuery } from '../apis';
import { setFieldAuditLog } from '..';
import queryKey from '../queryKey';
import { buildAuditQueryParams } from '../helpers';

// GET /api/audit-log (AuditController.cs) — Portion A internal reader (developer-portal-audit-read-ui).
// Mirrors useGetListAppInstance.js: React Query fetches, then dispatches the result into the
// per-feature redux slice so the table/pagination can read it via useSelector.
const useGetAuditLog = ({ pageIndex, pageSize, filterState }) => {
  const dispatch = useDispatch();
  const params = buildAuditQueryParams(filterState, pageIndex, pageSize);

  const query = useQuery({
    queryKey: queryKey.getList(JSON.stringify(params)),
    queryFn: () => getAuditLogQuery(params),
  });

  useEffect(() => {
    dispatch(
      setFieldAuditLog({
        field: 'filter',
        value: { pageIndex, pageSize, ...filterState },
      }),
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pageIndex, pageSize, JSON.stringify(filterState)]);

  useEffect(() => {
    const data = query?.data?.data;
    if (data) {
      dispatch(setFieldAuditLog({ field: 'list', value: deepClone(data) }));
    }
  }, [query?.data, dispatch]);

  return query;
};

export default useGetAuditLog;
